import Box from '~/common/components/Box';
import GenericTooltip from '~/common/components/GenericTooltip';
import Text from '~/common/components/Texts/Text';
import lang from '~/pages/IncomeCalculator/language.json';

import BreakdownYearContainer from './styles/BreakdownYearContainer';

type TrendTitleProps = {
  isPositiveTrend: boolean;
};

const TrendTitle = ({ isPositiveTrend }: TrendTitleProps) => (
  <Text fontWeight={500} fontSize="lg">
    {lang.TREND_ANALYSIS} &mdash;&nbsp;
    {isPositiveTrend ? lang.POSITIVE_TREND : lang.NEGATIVE_TREND}&emsp;
    <GenericTooltip label={lang.TIP_TREND_ANALYSIS} />
  </Text>
);

type TrendingAnalysisProps = {
  isPositiveTrend?: 'true' | 'false' | (Record<never, never> & string);
  grossMinusCogs?: number;
  expenses?: number;
  tangibleIncome?: number;
};

const TrendingAnalysis = ({
  isPositiveTrend,
  grossMinusCogs,
  expenses,
  tangibleIncome,
}: Readonly<TrendingAnalysisProps>) => {
  if (!isPositiveTrend) {
    return null;
  }

  return (
    <BreakdownYearContainer
      title={<TrendTitle isPositiveTrend={isPositiveTrend === 'true'} />}
    >
      <Box fontSize="sm">
        <Text>
          {lang.PER_CHANGE_GROSS_MINUS_COGS}&nbsp;
          {(grossMinusCogs ?? 0) * 100}%
        </Text>
        <Text pt={2}>
          {lang.PER_CHANGE_EXPENSES}&nbsp;
          {(expenses ?? 0) * 100}%
        </Text>
        <Text pt={2}>
          {lang.PER_CHANGE_TANGIBLE}&nbsp;
          {(tangibleIncome ?? 0) * 100}%
        </Text>
      </Box>
    </BreakdownYearContainer>
  );
};

export default TrendingAnalysis;
